"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signupFormConstraints = exports.passwordInlineConstraints = void 0;
const passwordInlineConstraints = exports.passwordInlineConstraints = {
  lowerCase: {
    hasLowerCase: true
  },
  upperCase: {
    hasUpperCase: true
  },
  number: {
    hasNumber: true
  },
  AWSSplChars: {
    hasAWSPasswordSplChar: true
  },
  length: {
    length: {
      minimum: 8
    }
  }
};
const signupFormConstraints = exports.signupFormConstraints = {
  nickname: {
    presence: {
      allowEmpty: false
    }
  },
  email: {
    presence: {
      allowEmpty: false
    },
    email: {
      message: "'%{value}' is not valid"
    }
  },
  password: {
    presence: {
      allowEmpty: false
    },
    hasLowerCase: true,
    hasUpperCase: true,
    hasNumber: true,
    hasAWSPasswordSplChar: true,
    length: {
      minimum: 8
    }
  }
};